import React, { Component } from "react";
import { getRequest } from "../api";

import Main from "../layouts/Main";

import { BlogItems, BlogSidebar } from "../components/Blog";
import { Subscribe } from "../components/HomePage";
import PageBanner from "../components/PageBanner";

class Blog extends Component {
  state = {
    blogPosts: [],
    assets: [],
    limit: 9,
    skip: 0,
    tableDataTotal: 0,
    currentPage: 0,
    totalPages: 0,
    paginationList: []
  };

  paginateTable = page => {
    const { totalPages, limit } = this.state;
    if (page <= totalPages && page > 0) {

      this.setState(
        {
          skip: page * limit
        },
        () => this.getBlogPosts()
      );
    }
  };

  getBlogPosts = async () => {
    const { limit, skip } = this.state;

    try {
      const res = await getRequest({
        url: "entries",
        params: {
          access_token: "qvwzHgDak_-zkrmMQidw7IXtM4U4Xs-M9SdFJl6kJMM",
          limit,
          skip,
          content_type: "blogPost"
        }
      });

      const tableDataTotal = res.data.total;
      const currentPage = skip / limit + 1;
      const totalPages = Math.ceil(tableDataTotal / limit);

      const pageNumbers = Array(totalPages)
        .fill(0)
        .map((x, i) => i + 1);

      const paginationBase = Math.floor((currentPage - 1) / 5) * 5;
      const paginationStart = paginationBase + 1;
      const paginationEnd = paginationBase + 5;

      const paginationList = pageNumbers.filter(
        page => page >= paginationStart && page <= paginationEnd
      );

      this.setState({
        blogPosts: res.data.items,
        assets: res.data.includes.Asset,
        tableDataTotal,
        currentPage,
        totalPages,
        pageNumbers,
        paginationList
      });
    } catch (error) {
      console.log(error);
    }
  };

  componentDidMount() {
    this.getBlogPosts();
  }

  render() {
    return (
      <Main>
        <PageBanner title="Resources" />
        <section className="ls s-pb-30 s-pt-60 s-pt-md-90 s-py-lg-90 s-py-xl-120">
          <div className="container">
            <div className="row c-gutter-60">
              <BlogItems {...this.state} paginateTable={this.paginateTable} />
              {/* <BlogSidebar {...this.state} /> */}
            </div>
          </div>
        </section>
      </Main>
    );
  }
}

export default Blog;
